"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("./Button");
const ButtonGroup_1 = require("./ButtonGroup");
const ButtonSelect = ({ onChange, options, value }) => {
    return ((0, jsx_runtime_1.jsx)(ButtonGroup_1.ButtonGroup, { activeId: value, onChange: onChange, children: options.map(options => (0, jsx_runtime_1.jsx)(Button_1.Button, { color: 'primary', variant: "outlined", children: options.label }, options.value)) }));
};
exports.ButtonSelect = ButtonSelect;
